var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiptap-vuetify',{attrs:{"card-props":{ flat: true, outlined: true, height: 300 },"extensions":_vm.extensions},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }